let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kv0CL")).then(() => parcelRequire('lEOMN'));